import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { GeneticMaterialService, InventoryTypeService, PeriodService, PropertyService, PropertyTypeService, RegionService, SpacingService, StandService, VendorService, ZoneService } from 'cbd-proxies';

FieldBuilder.setNamespace('Inventory');

const buildTechnicalIdField = (key: string, label: string): FieldDefinition =>
  FieldBuilder
    .number(key, label)
    .readOnly()
    .hideInChildForms()
    .hideByDefault()
    .build();

export const DRONEFLIGHT_FIELDS: FieldDefinition[] = [
  FieldBuilder.number('cycleValue', 'Entity.DroneFlight.StandCycle').readOnly().hideInChildForms().build(),
  FieldBuilder.number('rotationValue', 'Entity.DroneFlight.StandRotation').readOnly().hideInChildForms().build(),
  FieldBuilder.foreignKey('standId', 'Entity.Stand', StandService)
    .display('name')
    .displayFromNested('standName')
    .sortBy('standName')
    .hideInChildForms()
    .readOnly()
    .build(),
  FieldBuilder.foreignKey('propertyId', 'Entity.Property', PropertyService)
    .display('name')
    .displayFromNested('propertyName')
    .sortBy('propertyName')
    .hideInChildForms()
    .readOnly()
    .build(),
  FieldBuilder.foreignKey('zoneId', 'Entity.Zone', ZoneService)
    .display('name')
    .displayFromNested('zoneName')
    .sortBy('zoneName')
    .hideInChildForms()
    .readOnly()
    .build(),
  FieldBuilder.foreignKey('regionId', 'Entity.Region', RegionService)
    .display('name')
    .displayFromNested('regionName')
    .sortBy('regionName')
    .hideInChildForms()
    .readOnly()
    .build(),
  FieldBuilder.foreignKey('propertyTypeId', 'Entity.PropertyType', PropertyTypeService)
    .display('name')
    .displayFromNested('propertyTypeName')
    .sortBy('propertyTypeName')
    .hideInChildForms()
    .readOnly()
    .build(),
  buildTechnicalIdField('id', 'Id'),
  FieldBuilder
    .number('area', 'Entity.DroneFlight.Area')
    .required()
    .decimal()
    .build(),
  FieldBuilder
    .date('flightDate', 'Entity.DroneFlight.FlightDate')
    .required()
    .build(),
  FieldBuilder
    .number('treeCount', 'Entity.DroneFlight.TreeCount')
    .required()
    .build(),
  FieldBuilder
    .number('realDensity', 'Entity.DroneFlight.RealDensity')
    .decimal()
    .build(),
  FieldBuilder
    .number('theoreticalDensity', 'Entity.DroneFlight.TheoreticalDensity')
    .decimal()
    .build(),
  FieldBuilder
    .number('survivalPercentage', 'Entity.DroneFlight.SurvivalPercentage')
    .decimal()
    .build(),
  FieldBuilder
    .checkbox('isLastInventory', 'Entity.DroneFlight.IsLastInventory')
    .build(),
  FieldBuilder.foreignKey(
    'silvicultureVendorId',
    'Entity.DroneFlight.SilvicultureVendor',
    VendorService
  )
    .display('fantasyName')
    .displayFromNested('silvicultureVendorFantasyName')
    .sortBy('silvicultureVendorFantasyName')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey(
    'flightVendorId',
    'Entity.DroneFlight.FlightVendor',
    VendorService
  )
    .required()
    .display('fantasyName')
    .displayFromNested('flightVendorFantasyName')
    .sortBy('flightVendorFantasyName')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey(
    'countingVendorId',
    'Entity.DroneFlight.CountingVendor',
    VendorService
  )
    .required()
    .display('fantasyName')
    .displayFromNested('countingVendorFantasyName')
    .sortBy('countingVendorFantasyName')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey(
    'spacingId',
    'Entity.Spacing',
    SpacingService
  )
    .display('name')
    .displayFromNested('spacingName')
    .sortBy('spacingName')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey(
    'periodId',
    'Entity.Period',
    PeriodService
  )
    .required()
    .display('name')
    .displayFromNested('periodName')
    .sortBy('periodName')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey(
    'geneticMaterialId',
    'Entity.GeneticMaterial',
    GeneticMaterialService
  )
    .required()
    .display('name')
    .displayFromNested('geneticMaterialName')
    .sortBy('geneticMaterialName')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey(
    'inventoryTypeId',
    'Entity.InventoryType',
    InventoryTypeService
  )
    .required()
    .display('name')
    .displayFromNested('inventoryTypeName')
    .sortBy('inventoryTypeName')
    .keyField('id')
    .build(),
];

export const DRONEFLIGHT_CONFIG = {
  entityName: 'DroneFlight',
  localizationKey: 'Inventory::Entity.DroneFlight',
  fields: DRONEFLIGHT_FIELDS,
  permission: 'PlanningInventory.DroneFlights',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Inventory + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.TablesInventory + MENU_NAME_SUFFIX,
};
